import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import CustomIcon from '@Assets/images/icons';
import { ForgotPasswordViewPropsType } from '../ForgotPasswordView/types';
import ContentLoader from 'react-content-loader';
import { loginUserWithEmailPasswordSuccessAction } from '@Redux/store/user/actions';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { registerConfirmUser } from '@Redux/store/user/actions';
import { StoreType } from '@Redux/store/types';

const ConfirmEmail: React.FC<ForgotPasswordViewPropsType> = () => {
	const query = new URLSearchParams(useLocation().search);
	const tokenEmail: string | null = query.get('token');

	const loading = useSelector(
		(state: StoreType) => state.user.registerConfirm.loading
	);

	const statusOfRequest = useSelector(
		(state: StoreType) => state.user.registerConfirm.status
	);

	const ErrorOfRequest = useSelector(
		(state: StoreType) => state.user.registerConfirm.error
	);

	const dispatch = useDispatch();

	const confirmEmailRender = () => {
		dispatch(registerConfirmUser(tokenEmail));
	};

	const intl = useIntl();
	useEffect(() => {
		confirmEmailRender();
	}, []);

	return (
		<>
			<div className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework">
				<div className="text-center mb-1">
					{loading ? (
						<div className="h-50">
							<ContentLoader
								speed={2}
								width={500}
								height={300}
								viewBox="0 0 500 300"
								backgroundColor="#f3f3f3"
								foregroundColor="#ecebeb"
							>
								<circle cx="201" cy="36" r="34" />
								<rect x="8" y="103" rx="0" ry="0" width="380" height="28" />
								<rect x="9" y="151" rx="0" ry="0" width="380" height="41" />
								<rect x="10" y="205" rx="0" ry="0" width="380" height="42" />
								<rect x="479" y="1" rx="0" ry="0" width="1" height="10" />
								<rect x="498" y="80" rx="0" ry="0" width="0" height="49" />
								<rect x="485" y="185" rx="0" ry="0" width="0" height="7" />
								<rect x="10" y="262" rx="0" ry="0" width="380" height="23" />
							</ContentLoader>
						</div>
					) : !loading && statusOfRequest === 'success' ? (
						<>
							<div className="div">
								<CustomIcon icon="checkCircle" className="" />
								<h1 className="text-dark mb-3 mt-5 pt-5">
									{intl.formatMessage({
										id: 'AUTH.REGISTER.CONFIRMEMAIL.2',
									})}{' '}
								</h1>
								<div className="text-gray-400 fw-bold fs-5 mt-5 ">
									<p>
										{intl.formatMessage({
											id: 'AUTH.REGISTER.CONFIRMEMAIL.3',
										})}
									</p>
								</div>
							</div>
							<div className="d-flex flex-wrap justify-content-center pb-lg-0">
								<Link to="/dashboard">
									<button type="button" className="btn text-primary fw-bolder">
										{intl.formatMessage({
											id: 'BTN.GODASHBOARD',
										})}
									</button>
								</Link>{' '}
							</div>
						</>
					) : ErrorOfRequest === null ? (
						<>
							<div className="div"></div>
						</>
					) : (
						<>
							<div className="div mb-4">
								<CustomIcon icon="alertSignRed" className="" />
							</div>
							<h1 className="text-dark mb-3 mt-5 pt-5">
								{intl.formatMessage({
									id: 'AUTH.REGISTER.REGISTERSENDVIEW.3',
								})}{' '}
							</h1>
							<div className="text-gray-400 fw-bold fs-5 mt-5 ">
								<p>
									{intl.formatMessage({
										id: 'AUTH.REGISTER.CONFIRMEMAIL.1',
									})}
								</p>
							</div>
							<div className="d-flex col-12 flex-wrap justify-content-center pb-lg-0 w-100">
								<button
									type="button"
									className="col-12 btn btn-lg btn-primary fw-bolder me-4 mb-3"
									// onClick={} acá hay que agregar la función a desarrollar en back de reenvío de token
								>
									<span className="indicator-label ">
										{intl.formatMessage({
											id: 'AUTH.REGISTER.REGISTERSENDVIEW.5',
										})}
									</span>
								</button>
							</div>
							<div className="d-flex flex-wrap justify-content-center pb-lg-0">
								<Link to="/auth/login">
									<button type="button" className="btn text-primary fw-bolder">
										{intl.formatMessage({
											id: 'AUTH.REGISTER.REGISTERSENDVIEW.6',
										})}
									</button>
								</Link>{' '}
							</div>
						</>
					)}
				</div>
			</div>
		</>
	);
};

export default ConfirmEmail;
